import React, { Component } from "react";
import httpService from "../../services/httpService";
import config from "../../config.json";
import { Spinner, Accordion, Card, Modal, Button } from "react-bootstrap";
import { ButtonGroup } from "react-bootstrap";
import { MdDone } from "react-icons/md";
import authService from "../../services/authService";
import HledatOsobu from "../common/HledatOsobu";
import CovidPrehled from "./CovidPrehled";
import UzivatelDetail from "../Sprava/UzivatelDetail";

class CovidBooking extends Component {
  state = { terminy: [], covid_test: [], typTestu: "1" };
  timer = false;

  componentDidMount = () => {
    this.setState({
      login: authService.getCurrentUser().login,
      skryt: true,
    });
    this.nactiTerminy();
    this.nactiCiselniky();
  };

  nactiCiselniky = async () => {
    const ciselniky = await httpService.post(
      config.apiEndpoint + "covid/ciselniky.php"
    );
    this.setState({ ciselniky: ciselniky.data });
  };

  nactiTerminy = async () => {
    const { datum } = this.state;
    const terminy = await httpService.post(
      config.apiEndpoint + "covid/terminy.php",
      { datum }
    );
    this.setState({
      terminy: terminy.data.terminy,
      todayStats: terminy.data.todayStats,
      stats: terminy.data.stats,
      datum: terminy.data.datum,
      loaded: true,
    });
    if (this.timer) {
      clearTimeout(this.timer);
    }
    this.timer = setTimeout(() => this.nactiTerminy(), 15000);
  };

  zmenTermin = async (datum) => {
    await this.setState({ datum });
    this.nactiTerminy();
  };

  zrusitRezervaci = async (ordinace_id, rezervace_id, confirmed) => {
    let { novaRezervace, login } = this.state;
    if (confirmed) {
      let { terminy } = this.state;
      const index1 = terminy.findIndex((t) => t.ordinace_id === ordinace_id);
      if (index1 >= 0) {
        const index2 = terminy[index1].terminy.findIndex(
          (t2) => t2.rezervace_id === rezervace_id
        );
        if (index2 >= 0) {
          terminy[index1].terminy[index2].rezervace_id = null;
        }
      }
      /*terminy
        .find((t) => t.ordinace_id === ordinace_id)
        .terminy.find(
          (t2) => t2.rezervace_id === rezervace_id
        ).rezervace_id = null;*/
      this.setState({ terminy });
      await httpService.post(config.apiEndpoint + "covid/zrusitRezervaci.php", {
        rezervace_id,
      });
      this.nactiTerminy();
      if (novaRezervace) {
        this.zmenaOsoby(login);
      }
    } else {
      if (window.confirm("Zrušit rezervaci vyšetření?")) {
        this.zrusitRezervaci(ordinace_id, rezervace_id, true);
      }
    }
  };

  pozitivniVysledek = async (ordinace_id, rezervace_id, confirmed) => {
    if (confirmed) {
      let { terminy } = this.state;
      terminy
        .find((t) => t.ordinace_id === ordinace_id)
        .terminy.find((t2) => t2.rezervace_id === rezervace_id).otazkaVysledek =
        "0";
      this.setState({ terminy });
      await httpService.post(
        config.apiEndpoint + "covid/pozitivniVysledek.php",
        { rezervace_id }
      );
      this.nactiTerminy();
    } else {
      if (window.confirm("Potvrdit pozitivní výsledek testu?")) {
        this.pozitivniVysledek(ordinace_id, rezervace_id, true);
      }
    }
  };

  negativniVysledek = async (ordinace_id, rezervace_id, confirmed) => {
    if (confirmed) {
      let { terminy } = this.state;
      terminy
        .find((t) => t.ordinace_id === ordinace_id)
        .terminy.find((t2) => t2.rezervace_id === rezervace_id).otazkaVysledek =
        "1";
      terminy
        .find((t) => t.ordinace_id === ordinace_id)
        .terminy.find(
          (t2) => t2.rezervace_id === rezervace_id
        ).pozitivniVysledek = null;
      this.setState({ terminy });
      await httpService.post(
        config.apiEndpoint + "covid/negativniVysledek.php",
        { rezervace_id }
      );
      this.nactiTerminy();
    } else {
      if (window.confirm("Potvrdit negativní výsledek testu?")) {
        this.negativniVysledek(ordinace_id, rezervace_id, true);
      }
    }
  };

  potvrditNavstevu = async (ordinace_id, rezervace_id, confirmed) => {
    if (confirmed) {
      let { terminy } = this.state;
      terminy
        .find((t) => t.ordinace_id === ordinace_id)
        .terminy.find(
          (t2) => t2.rezervace_id === rezervace_id
        ).priselCas = true;
      this.setState({ terminy, novaRezervace: false });
      await httpService.post(
        config.apiEndpoint + "covid/potvrditNavstevu.php",
        { rezervace_id }
      );
      this.nactiTerminy();
    } else {
      if (window.confirm("Potvrdit účast na vyšetření?")) {
        this.potvrditNavstevu(ordinace_id, rezervace_id, true);
      }
    }
  };

  zmenaCasu = async (cas, login) => {
    await this.setState({ cas });
    this.zmenaOsoby(login);
  };

  zmenaOsoby = async (login) => {
    const { ordinace_id, cas, bezRezervace } = this.state;
    await this.setState({ login });
    this.novaRezervaceShow(ordinace_id, cas, bezRezervace);
  };

  novaRezervace = async () => {
    const { login, ordinace_id, cas, bezRezervace, externi } = this.state;
    await httpService.post(config.apiEndpoint + "covid/novaRezervace.php", {
      login,
      ordinace_id,
      cas,
      bezRezervace,
      externi,
    });
    this.setState({ novaRezervace: false, bezRezervace: false });
    this.nactiTerminy();
  };

  blokovat = async (ordinace_id, cas) => {
    await httpService.post(config.apiEndpoint + "covid/blokovat.php", {
      ordinace_id,
      cas,
    });
    this.nactiTerminy();
  };

  odblokovat = async (blokace_id) => {
    await httpService.post(config.apiEndpoint + "covid/odblokovat.php", {
      blokace_id,
    });
    this.nactiTerminy();
  };

  novaRezervaceShow = async (ordinace_id, cas, bezRezervace) => {
    const { login } = this.state;
    const osoba = await httpService.post(
      config.apiEndpoint + "covid/osobaDetail.php",
      { login, cas }
    );
    this.setState({
      osoba: osoba.data,
      novaRezervace: true,
      ordinace_id: ordinace_id,
      cas: cas,
      bezRezervace,
    });
  };

  smazatRezervaci = async (rezervace_id, confirmed) => {
    if (confirmed) {
      await httpService.post(config.apiEndpoint + "covid/delRezervace.php", {
        rezervace_id,
      });
      this.nactiTerminy();
    } else {
      if (window.confirm("Skutečně nevratně smazat záznam?")) {
        this.smazatRezervaci(rezervace_id, true);
      }
    }
  };

  odeslatUZIS = async (rezervace_id, confirmed, alertErrors) => {
    if (confirmed) {
      const odpoved = await httpService.post(
        config.apiEndpoint + "covid/odeslatUzis.php",
        {
          rezervace_id,
        }
      );
      if (alertErrors && odpoved.data.Chyby && odpoved.data.Chyby.length > 0) {
        let alertText = "";
        for (let i = 0; i < odpoved.data.Chyby.length; i++) {
          alertText += (i > 0 ? "\n" : "") + odpoved.data.Chyby[i].Nazev;
        }
        alert(alertText);
      } else {
        this.setState({ showUZIS: false });
      }
      this.nactiTerminy();
    } else {
      if (window.confirm("Odeslat na ÚZIS?")) {
        this.odeslatUZIS(rezervace_id, true);
      }
    }
  };

  hromadnaPrihlaska = async (confirmed) => {
    if (confirmed) {
      const { datum, hromadnaFirmaId, hromadnaOrdinaceId } = this.state;
      await httpService.post(
        config.apiEndpoint + "covid/hromadnaPrihlaska.php",
        { datum, firma_id: hromadnaFirmaId, ordinace_id: hromadnaOrdinaceId }
      );
      this.nactiTerminy();
      this.setState({
        showHromadnaPrihlaska: false,
        hromadnaOrdinaceId: false,
        hrommadnaFirmaId: false,
      });
    } else {
      if (window.confirm("Skutečně odeslat hromadnou přihlášku?")) {
        this.hromadnaPrihlaska(true);
      }
    }
  };

  doplnitCisloZadanky = async (rezervace_id, cisloZadanky) => {
    let { showUZIS } = this.state;
    await httpService.post(
      config.apiEndpoint + "covid/doplnitCisloZadanky.php",
      { rezervace_id, cisloZadanky }
    );
    await this.nactiTerminy();
    const index = this.state.terminy.findIndex(
      (t) => t.ordinace_id === showUZIS.ordinace_id
    );
    showUZIS = this.state.terminy[index].terminy.find(
      (t) => t.rezervace_id === showUZIS.rezervace_id
    );
    this.setState({ showUZIS });
  };

  samotest = async (pozitivni) => {
    const { datum, samotestLogin, typTestu } = this.state;
    const result = await httpService.post(
      config.apiEndpoint + "covid/samotest.php",
      { datum, login: samotestLogin, pozitivni, typTestu }
    );
    if (result.data.error) {
      alert(result.data.error);
    } else {
      this.setState({ showSamotest: false, samotestLogin: false });
      this.nactiTerminy();
    }
  };

  render() {
    const {
      datum,
      loaded,
      novaRezervace,
      ordinace_id,
      osoba,
      login,
      cas,
      showPrehled,
      bezRezervace,
      todayStats,
      stats,
      pdf,
      hledatOsobu,
      show,
      showLogin,
      showSamotest,
      externi,
      exportPDF,
      filter,
      showUZIS,
      showHromadnaPrihlaska,
      hromadnaOrdinaceId,
      hromadnaFirmaId,
      ciselniky,
      samotestLogin,
      typTestu,
    } = this.state;
    let { skryt } = this.state;
    let terminy = JSON.parse(JSON.stringify(this.state.terminy));

    if (hledatOsobu && hledatOsobu !== "") {
      terminy.map(
        (t, index) =>
          (terminy[index].terminy = terminy[index].terminy.filter(
            (n) =>
              String(n.jmeno)
                .toLowerCase()
                .includes(String(hledatOsobu).toLowerCase()) ||
              n.rezervace_den_id === hledatOsobu
          ))
      );
      skryt = false;
    }

    const user = authService.getCurrentUser();
    return (
      <React.Fragment>
        <Modal
          show={showSamotest}
          onHide={() =>
            this.setState({ showSamotest: false, samotestLogin: false })
          }
        >
          <Modal.Header closeButton>
            Zadání výsledku samotestu zaměstnance
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-md-12">
                <HledatOsobu
                  onSelect={(e) => this.setState({ samotestLogin: e })}
                />
              </div>
              <div className="col-md-6">
                <small>Datum</small>
                <input
                  type="date"
                  className="form-control"
                  value={datum}
                  onChange={(e) => this.zmenTermin(e.target.value)}
                />
              </div>
              <div className="col-md-6">
                <small>Typ testu</small>
                <select
                  className="form-control"
                  value={typTestu}
                  onChange={(e) => this.setState({ typTestu: e.target.value })}
                >
                  {ciselniky &&
                    ciselniky.covid_test &&
                    ciselniky.covid_test.map((t) => (
                      <option value={t.test_id} key={t.test_id}>
                        {t.nazev}
                      </option>
                    ))}
                </select>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="danger"
              disabled={!samotestLogin}
              onClick={() => this.samotest(1)}
            >
              Pozitivní výsledek
            </Button>
            <Button
              variant="success"
              disabled={!samotestLogin}
              onClick={() => this.samotest(0)}
            >
              Negativní výsledek
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal
          show={showHromadnaPrihlaska}
          onHide={() => this.setState({ showHromadnaPrihlaska: false })}
        >
          <Modal.Header closeButton>
            Hromadná přihláška firmy na testování
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-md-6">
                {" "}
                <small>Datum</small>
                <input
                  type="date"
                  className="form-control"
                  value={datum}
                  onChange={(e) => this.zmenTermin(e.target.value)}
                  style={{ width: "100%" }}
                />
              </div>
              <div className="col-md-6">
                <small>Testovací místo</small>
                <select
                  name="hromadnaOrdinaceId"
                  className="form-control"
                  value={hromadnaOrdinaceId}
                  onChange={(e) =>
                    this.setState({ hromadnaOrdinaceId: e.target.value })
                  }
                >
                  {!hromadnaOrdinaceId && (
                    <option value="">Zvolte testovací místo</option>
                  )}
                  {ciselniky &&
                    ciselniky.ordinace &&
                    ciselniky.ordinace.map((o) => (
                      <option value={o.ordinace_id} key={o.ordinace_id}>
                        {o.nazev}
                      </option>
                    ))}
                </select>
              </div>
              <div className="col-md-12">
                <small>Firma</small>
                <select
                  name="hromadnaFirmaId"
                  className="form-control"
                  value={hromadnaFirmaId}
                  onChange={(e) =>
                    this.setState({ hromadnaFirmaId: e.target.value })
                  }
                >
                  {!hromadnaFirmaId && <option value="">Zvolte firmu</option>}
                  {ciselniky &&
                    ciselniky.firmy &&
                    ciselniky.firmy.map((o) => (
                      <option value={o.firma_id} key={o.firma_id}>
                        {o.nazev}
                      </option>
                    ))}
                </select>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="primary"
              disabled={!(hromadnaOrdinaceId && hromadnaFirmaId)}
              onClick={() => this.hromadnaPrihlaska()}
            >
              Odeslat
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal
          show={showUZIS}
          onHide={() => this.setState({ showUZIS: false })}
        >
          <Modal.Header closeButton>Detail odeslání na ÚZIS</Modal.Header>
          <Modal.Body>
            {showUZIS && showUZIS.odpovedUZIS ? (
              <div className="row">
                <div className="col-md-6">
                  <small>Status</small>
                  {showUZIS.odpovedUZIS.Status ? (
                    <div className="text-success">OK</div>
                  ) : (
                    <div className="text-danger">Error</div>
                  )}
                </div>
                <div className="col-md-6">
                  <small>Zpráva</small>
                  <div>{showUZIS.odpovedUZIS.Zprava}</div>
                </div>
                <div className="col-md-6">
                  <small>Číslo žádanky</small>
                  <div>{showUZIS.odpovedUZIS.Cislo}</div>
                  {showUZIS.cisloZadanky === "0" ? (
                    <div>
                      <small>Doplňte číslo žádanky</small>
                      <input
                        type="text"
                        className="form-control"
                        onBlur={(e) =>
                          this.doplnitCisloZadanky(
                            showUZIS.rezervace_id,
                            e.target.value
                          )
                        }
                      />
                    </div>
                  ) : (
                    showUZIS.cisloZadanky
                  )}
                </div>
                {showUZIS &&
                  showUZIS.odpovedUZIS &&
                  showUZIS.odpovedUZIS.Chyby &&
                  showUZIS.odpovedUZIS.Chyby.length > 0 && (
                    <div className="col-md-12">
                      <small>Chyby žádanky</small>
                      <div className="row">
                        {showUZIS.odpovedUZIS.Chyby.map((ch, index) => (
                          <div className="col-md-6" key={index}>
                            {ch.Nazev}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
              </div>
            ) : (
              <div>
                <small>Doplňte získané číslo žádanky</small>
                <input
                  type="text"
                  onBlur={(e) =>
                    this.doplnitCisloZadanky(
                      showUZIS.rezervace_id,
                      e.target.value
                    )
                  }
                  className="form-control"
                />
              </div>
            )}
          </Modal.Body>
          {showUZIS &&
            ((showUZIS.odpovedUZIS &&
              showUZIS.odpovedUZIS.Chyby &&
              showUZIS.odpovedUZIS.Chyby.length > 0) ||
              !showUZIS.odpovedUZIS) && (
              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={() =>
                    this.odeslatUZIS(showUZIS.rezervace_id, true, true)
                  }
                >
                  Odeslat do UZISu
                </Button>
                <a
                  href={
                    config.apiEndpoint +
                    "covid/presmerovatUZIS.php?rezervace_id=" +
                    showUZIS.rezervace_id +
                    "&token=" +
                    authService.getJwt()
                  }
                  className="btn btn-secondary"
                  target="_blank"
                >
                  Vyplnit ručně
                </a>
              </Modal.Footer>
            )}
        </Modal>
        <Modal
          show={this.state.show}
          onHide={() => this.setState({ show: false })}
          style={{ marginTop: "30px" }}
          dialogClassName="modal-90w"
        >
          <Modal.Header closeButton>Nastavení uživatele</Modal.Header>
          <Modal.Body>
            {showLogin && (
              <UzivatelDetail login={showLogin} onChange={this.nactiTerminy} />
            )}
          </Modal.Body>
        </Modal>
        <Modal
          show={exportPDF}
          onHide={() => this.setState({ exportPDF: false })}
          dialogClassName="modal-90w"
        >
          <Modal.Header closeButton>
            Hromadný export potvrzení pro tisk
          </Modal.Header>
          <Modal.Body>
            <div className="alert alert-warning">
              Dejte tomu chvilku - generování PDF pro všechny zabere pár vteřin
              :)
            </div>
            {exportPDF && (
              <iframe
                src={
                  config.apiEndpoint +
                  "covid/pdfAll.php?ordinace_id=" +
                  exportPDF +
                  "&datum=" +
                  datum +
                  "&token=" +
                  authService.getJwt()
                }
                style={{ width: "100%", border: "none", height: "72vh" }}
              />
            )}
          </Modal.Body>
        </Modal>
        <Modal
          show={pdf}
          onHide={() => this.setState({ pdf: false })}
          dialogClassName="modal-90w"
        >
          <Modal.Header closeButton>Potvrzení o testu</Modal.Header>
          <Modal.Body>
            <iframe
              src={
                config.apiEndpoint +
                "covid/pdf.php?rezervace_id=" +
                pdf +
                "&token=" +
                authService.getJwt()
              }
              style={{ width: "100%", border: "none", height: "75vh" }}
            />
          </Modal.Body>
        </Modal>
        <Modal
          show={showPrehled}
          onHide={() => this.setState({ showPrehled: false })}
          dialogClassName="modal-90w"
        >
          <Modal.Header closeButton>Přehled testovaných osob</Modal.Header>
          <Modal.Body>
            {showPrehled && (
              <CovidPrehled
                onChangeFilter={(filter) => this.setState({ filter })}
              />
            )}
          </Modal.Body>
          <Modal.Footer>
            <input
              type="date"
              value={datum}
              className="form-control"
              style={{ width: "180px" }}
              onChange={(e) => this.zmenTermin(e.target.value)}
            />
            <Button
              href={
                config.apiEndpoint +
                "covid/pdfFilter.php?datum=" +
                datum +
                "&" +
                (filter ? "filter=" + JSON.stringify(filter) + "&" : "") +
                "token=" +
                authService.getJwt()
              }
            >
              Export PDF potvrzení
            </Button>
            <Button
              href={
                config.apiEndpoint +
                "covid/prehledCSV.php?" +
                (filter ? "filter=" + JSON.stringify(filter) + "&" : "") +
                "token=" +
                authService.getJwt()
              }
            >
              Export CSV
            </Button>
            <Button
              variant="danger"
              onClick={() => this.setState({ showPrehled: false })}
            >
              Zavřít
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal
          show={novaRezervace}
          onHide={() => this.setState({ novaRezervace: false })}
        >
          <Modal.Header closeButton>
            {bezRezervace ? (
              "Zadání testu bez rezervace"
            ) : (
              <span>
                Nová rezervace{" "}
                {ordinace_id &&
                  terminy &&
                  terminy.find((t) => t.ordinace_id === ordinace_id).ordinace}
              </span>
            )}
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              {(user.covidAdmin === "1" || user.pocetPodrizenych) && (
                <div className="col-md-12">
                  <HledatOsobu onSelect={(e) => this.zmenaOsoby(e)} />
                </div>
              )}
              <div className="col-md-6">
                <small>Čas rezervace</small>
                <div>
                  {bezRezervace ? (
                    <div>
                      <input
                        type="date"
                        value={cas}
                        className="form-control"
                        onChange={(e) =>
                          this.zmenaCasu(e.target.value, osoba.login)
                        }
                      />
                      <input
                        type="checkbox"
                        name="externi"
                        checked={externi === "1"}
                        onChange={(e) =>
                          this.setState({
                            externi: e.target.checked ? "1" : "0",
                          })
                        }
                      />{" "}
                      Externí testování?
                    </div>
                  ) : (
                    cas
                  )}
                </div>
              </div>
              <div className="col-md-6">
                <small>Jméno</small>
                <div>{osoba && osoba.jmeno}</div>
              </div>
            </div>
            {osoba && osoba.kolize && (
              <div
                className={
                  user.admin ? "alert alert-warning" : "alert alert-danger"
                }
                style={{ marginTop: "20px" }}
              >
                Tuto osobu nelze zapsat, protože byla vyšetřena před méně než
                sedmi dny a nebo má již platnou rezervaci za méně než sedm dnů:
                <ul>
                  {osoba.kolize.map((k) => (
                    <li key={k.rezervace_id}>
                      {k.casRezervace} (ID: {k.rezervace_id}){" "}
                      {k.lzePotvrdit && user.covidAdmin === "1" && (
                        <Button
                          variant="primary"
                          onClick={() =>
                            this.potvrditNavstevu(k.ordinace_id, k.rezervace_id)
                          }
                        >
                          Potvrdit návštěvu
                        </Button>
                      )}
                      {k.lzeZrusit && (
                        <Button
                          variant="primary"
                          onClick={() =>
                            this.zrusitRezervaci(k.ordinace_id, k.rezervace_id)
                          }
                        >
                          Zrušit kolizní termin
                        </Button>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              disabled={(user.admin !== "1" && osoba && osoba.kolize) || !osoba}
              onClick={() => this.novaRezervace()}
            >
              {bezRezervace ? "Potvrdit účast" : "Rezervovat"}
            </Button>
          </Modal.Footer>
        </Modal>
        <div style={{ paddingBottom: "20px" }} className="row">
          <div className="col-md-3">
            <small>Datum</small>
            <input
              type="date"
              className="form-control"
              value={datum}
              onChange={(e) => this.zmenTermin(e.target.value)}
              style={{ width: "100%" }}
            />
            {user.covidAdmin === "1" && (
              <a
                href={
                  config.apiEndpoint +
                  "covid/dnesekCSV.php?datum=" +
                  datum +
                  "&token=" +
                  authService.getJwt()
                }
                className="btn btn-primary"
                style={{ marginTop: "5px", width: "100%" }}
              >
                Export CSV dnešek
              </a>
            )}
          </div>
          <div className="col-md-6">
            {stats && (
              <div className="row">
                <div className="col-6">
                  <small>Celkem testů</small>
                  <div>{stats.pocet}</div>
                </div>
                <div className="col-6">
                  <small>Pozitivní výsledek</small>
                  <div>
                    {stats.pozitivni} ({stats.procento}%)
                  </div>
                </div>
                <div className="col-6">
                  <small>Pozitivní z ext. testu</small>
                  <div>{stats.pozitivniExt}</div>
                </div>
                <div className="col-6">
                  <small>Pozitivní posledních 14 dní (celkem)</small>
                  <div>{stats.poslednich14dni}</div>
                </div>
              </div>
            )}
          </div>
          <div className="col-md-3 text-right">
            {config.lazne === false && parseInt(user.pocetPodrizenych) > 0 && (
              <Button
                variant="success"
                style={{ width: "100%", marginBottom: "10px" }}
                onClick={() => this.setState({ showSamotest: true })}
              >
                Zadání samotestu
              </Button>
            )}
            {(user.covidAdmin === "1" ||
              parseInt(user.pocetPodrizenych) > 0) && (
              <Button
                variant="primary"
                onClick={() => this.setState({ showPrehled: true })}
                style={{ width: "100%" }}
              >
                Přehled osob
              </Button>
            )}
            {(user.covidAdmin === "1" ||
              parseInt(user.pocetPodrizenych) > 0) && (
              <Button
                variant="primary"
                onClick={() => this.setState({ showHromadnaPrihlaska: true })}
                style={{ width: "100%", marginTop: "10px" }}
              >
                Hromadná registrace na test
              </Button>
            )}
          </div>
        </div>
        {loaded ? (
          terminy && terminy.length > 0 ? (
            <Accordion defaultActiveKey={terminy.length === 1 ? 0 : null}>
              {terminy.map((t, index) => (
                <Card>
                  <Accordion.Toggle as={Card.Header} eventKey={index}>
                    {todayStats &&
                      todayStats.findIndex(
                        (s) => s.ordinace_id === t.ordinace_id
                      ) >= 0 && (
                        <div style={{ float: "right" }}>
                          {
                            <span>
                              Celkem:{" "}
                              {
                                todayStats.find(
                                  (s) => s.ordinace_id === t.ordinace_id
                                ).pocet_celkem
                              }
                              {" | "}
                              <span className="text-success">
                                Přišli:{" "}
                                {
                                  todayStats.find(
                                    (s) => s.ordinace_id === t.ordinace_id
                                  ).prisli
                                }
                              </span>
                              {" | "}
                              <span className="text-danger">
                                Nepřišli:{" "}
                                {
                                  todayStats.find(
                                    (s) => s.ordinace_id === t.ordinace_id
                                  ).neprisli
                                }
                              </span>
                              {" | "}
                              <span className="text-warning">
                                Ještě má přijít:{" "}
                                {
                                  todayStats.find(
                                    (s) => s.ordinace_id === t.ordinace_id
                                  ).maPrijit
                                }
                              </span>
                            </span>
                          }
                        </div>
                      )}
                    {t.ordinace}
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey={index}>
                    <Card.Body>
                      <div className="row">
                        {user.covidAdmin && (
                          <div className="col-md-3 pb-3">
                            <input
                              type="checkbox"
                              checked={skryt}
                              onChange={(e) =>
                                this.setState({ skryt: e.target.checked })
                              }
                            />{" "}
                            Skrýt dokončené testy
                          </div>
                        )}
                        <div className="col-md-4 pb-3">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Hledat osobu v dnešních testech"
                            value={hledatOsobu}
                            onChange={(e) =>
                              this.setState({ hledatOsobu: e.target.value })
                            }
                          />
                        </div>
                        <div className="col-md-5 pb-3 text-right">
                          {user.covidAdmin === "1" && (
                            <div className="btn-group">
                              <Button
                                onClick={() =>
                                  this.setState({ exportPDF: t.ordinace_id })
                                }
                              >
                                Všechna potvrzení v PDF
                              </Button>
                              <Button
                                variant="success"
                                onClick={() =>
                                  this.novaRezervaceShow(
                                    t.ordinace_id,
                                    datum,
                                    true
                                  )
                                }
                              >
                                Zadat test bez rezervace
                              </Button>
                            </div>
                          )}
                        </div>
                        {t &&
                          t.terminy &&
                          t.terminy.map(
                            (t2, index2) =>
                              (!skryt ||
                                (skryt &&
                                  (!t2.priselCas ||
                                    (t2.priselCas &&
                                      t2.ukazatVysledek === "1")))) && (
                                <div
                                  className="col-md-4"
                                  key={index2}
                                  style={{ paddingBottom: "10px" }}
                                >
                                  <Card>
                                    <Card.Header>
                                      {t2.priselCas && (
                                        <span
                                          className="text-success"
                                          style={{ float: "right" }}
                                        >
                                          <MdDone />
                                        </span>
                                      )}
                                      {t2.blokace_id && (
                                        <span
                                          style={{ float: "right" }}
                                          className="text-danger"
                                        >
                                          Blokováno
                                        </span>
                                      )}
                                      {t2.casFormatted}
                                    </Card.Header>
                                    <Card.Body>
                                      {user.covidAdmin === "1" &&
                                        t2.rezervace_den_id && (
                                          <div
                                            style={{
                                              float: "right",
                                              minWidth: "44px",
                                              border: "solid 1px #000",
                                              backgroundColor: "#333",
                                              color: "#FFF",
                                              textAlign: "center",
                                              height: "44px",
                                              lineHeight: "44px",
                                              fontSize: "30px",
                                            }}
                                            title="Číslo testu"
                                          >
                                            {t2.rezervace_den_id}
                                          </div>
                                        )}
                                      {t2.blokace_id ? (
                                        user.covidAdmin === "1" ? (
                                          <div className="text-center">
                                            <Button
                                              variant="success"
                                              onClick={() =>
                                                this.odblokovat(t2.blokace_id)
                                              }
                                            >
                                              Odblokovat
                                            </Button>
                                          </div>
                                        ) : (
                                          <div>
                                            Tento čas je blokován pro rezervace.
                                          </div>
                                        )
                                      ) : t2.rezervace_id ? (
                                        <div>
                                          {user.covidAdmin === "1" ? (
                                            <Button
                                              variant="link"
                                              style={{
                                                margin: "0px",
                                                padding: "0px",
                                              }}
                                              onClick={() =>
                                                this.setState({
                                                  show: true,
                                                  showLogin: t2.login,
                                                })
                                              }
                                            >
                                              {t2.jmeno}
                                            </Button>
                                          ) : (
                                            t2.jmeno
                                          )}
                                          <div>
                                            <small>
                                              <div>{t2.login}</div>
                                              {/*t2.zadaniCas} / {t2.zadaniLogin*/}
                                              {t2.mobil && (
                                                <div>
                                                  <strong>Mobil:</strong>{" "}
                                                  {t2.mobil}
                                                </div>
                                              )}
                                              <div className="row">
                                                <div className="col-6">
                                                  <strong>Firma:</strong>{" "}
                                                  {t2.firma}
                                                </div>
                                                <div className="col-6">
                                                  <strong>ZP:</strong>{" "}
                                                  {t2.zdravotniPojistovna}
                                                </div>
                                              </div>
                                            </small>
                                          </div>
                                          {t2.otazkaVysledek === "1" ||
                                          (t2.priselCas && user.admin === "1")
                                            ? user.covidAdmin === "1" && (
                                                <div className="text-center pt-2">
                                                  <div className="btn-group">
                                                    {t2.pozitivniVysledek ===
                                                    "1" ? (
                                                      <Button
                                                        variant="success"
                                                        onClick={() =>
                                                          this.negativniVysledek(
                                                            t2.ordinace_id,
                                                            t2.rezervace_id
                                                          )
                                                        }
                                                      >
                                                        Negativní?
                                                      </Button>
                                                    ) : (
                                                      <Button
                                                        variant="info"
                                                        onClick={() =>
                                                          this.pozitivniVysledek(
                                                            t2.ordinace_id,
                                                            t2.rezervace_id
                                                          )
                                                        }
                                                      >
                                                        Pozitivní?
                                                      </Button>
                                                    )}
                                                    {t2.odesilatUZIS === "1" &&
                                                      (t2.odeslanoUZIS ? (
                                                        <Button
                                                          onClick={() =>
                                                            this.setState({
                                                              showUZIS: t2,
                                                            })
                                                          }
                                                          className={
                                                            "btn " +
                                                            (t2.odpovedUZIS &&
                                                            t2.odpovedUZIS
                                                              .Status === true
                                                              ? parseInt(
                                                                  t2.odpovedUZIS
                                                                    .Cislo
                                                                ) > 0
                                                                ? "btn-success"
                                                                : "btn-primary"
                                                              : "btn-danger")
                                                          }
                                                        >
                                                          ÚZIS
                                                        </Button>
                                                      ) : (
                                                        <Button
                                                          className="btn btn-warning"
                                                          onClick={() =>
                                                            /*this.odeslatUZIS(
                                                              t2.rezervace_id
                                                            )*/
                                                            this.setState({
                                                              showUZIS: t2,
                                                            })
                                                          }
                                                        >
                                                          ÚZIS
                                                        </Button>
                                                      ))}
                                                    <Button
                                                      variant="secondary"
                                                      onClick={() =>
                                                        this.setState({
                                                          pdf: t2.rezervace_id,
                                                        })
                                                      }
                                                    >
                                                      PDF
                                                    </Button>
                                                    {user.admin === "1" && (
                                                      <Button
                                                        variant="danger"
                                                        onClick={() =>
                                                          this.smazatRezervaci(
                                                            t2.rezervace_id
                                                          )
                                                        }
                                                      >
                                                        Smazat
                                                      </Button>
                                                    )}
                                                  </div>
                                                </div>
                                              )
                                            : t2.priselCas &&
                                              user.covidAdmin === "1" && (
                                                <div className="text-center pt-2">
                                                  <div className="btn-group">
                                                    <Button
                                                      variant="secondary"
                                                      onClick={() =>
                                                        this.setState({
                                                          pdf: t2.rezervace_id,
                                                        })
                                                      }
                                                    >
                                                      PDF
                                                    </Button>
                                                    {user.admin === "1" && (
                                                      <Button
                                                        variant="danger"
                                                        onClick={() =>
                                                          this.smazatRezervaci(
                                                            t2.rezervace_id
                                                          )
                                                        }
                                                      >
                                                        Smazat
                                                      </Button>
                                                    )}
                                                  </div>
                                                </div>
                                              )}
                                          {!t2.priselCas && (
                                            <div className="text-center pt-2">
                                              <ButtonGroup>
                                                {user &&
                                                  user.covidAdmin === "1" && (
                                                    <React.Fragment>
                                                      <Button
                                                        variant="warning"
                                                        onClick={() =>
                                                          this.potvrditNavstevu(
                                                            t2.ordinace_id,
                                                            t2.rezervace_id
                                                          )
                                                        }
                                                      >
                                                        Přišel
                                                      </Button>
                                                      <Button
                                                        variant="secondary"
                                                        onClick={() =>
                                                          this.setState({
                                                            pdf: t2.rezervace_id,
                                                          })
                                                        }
                                                      >
                                                        PDF
                                                      </Button>
                                                    </React.Fragment>
                                                  )}
                                                {user &&
                                                  (user.covidAdmin === "1" ||
                                                    user.login === t2.login ||
                                                    user.login ===
                                                      t2.zadaniLogin) && (
                                                    <Button
                                                      variant="danger"
                                                      onClick={() =>
                                                        this.zrusitRezervaci(
                                                          t2.ordinace_id,
                                                          t2.rezervace_id
                                                        )
                                                      }
                                                    >
                                                      Zrušit
                                                    </Button>
                                                  )}
                                              </ButtonGroup>
                                            </div>
                                          )}
                                        </div>
                                      ) : (
                                        <div className="text-center">
                                          <div className="btn-group">
                                            <Button
                                              variant="success"
                                              onClick={() =>
                                                this.novaRezervaceShow(
                                                  t2.ordinace_id,
                                                  t2.cas
                                                )
                                              }
                                            >
                                              Rezervovat
                                            </Button>
                                            {user.covidAdmin === "1" && (
                                              <Button
                                                variant="danger"
                                                onClick={() =>
                                                  this.blokovat(
                                                    t2.ordinace_id,
                                                    t2.cas
                                                  )
                                                }
                                              >
                                                Blokovat
                                              </Button>
                                            )}
                                          </div>
                                        </div>
                                      )}
                                    </Card.Body>
                                  </Card>
                                </div>
                              )
                          )}
                      </div>
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
              ))}
            </Accordion>
          ) : (
            <div className="alert alert-danger">
              Tento den se nelze objednat na test
            </div>
          )
        ) : (
          <div className="text-warning">
            <Spinner animation="grow" size="sm" variant="warning" />
            Loading...
          </div>
        )}
      </React.Fragment>
    );
  }
}

export default CovidBooking;
